import React, { useState, useEffect, useContext, useRef } from 'react';

//***********************************Componentes PrimeReact************************************************* */
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { NumericFormat } from 'react-number-format';
import { Toast } from 'primereact/toast';
import { confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { Checkbox } from 'primereact/checkbox';
import { Tag } from 'primereact/tag';

//*******************************Componentes Generales********************************************* */
import Card from '../../../../Components/Card/Card';
import Loader from '../../../../Components/Loader/Loader';
import AgGrid from '../../../../Components/Tables/AgGrid/AgGrid';

//***********************************Servicios Generales******************************************************* */
import { toastShow } from '../../../../Services/ToastService';
import { useForm } from '../../../../Hooks/useForm';
import { getDateString, getDateTimeStringSQL, getDateTimeStringSQL24 } from '../../../../Services/Moment/Luxon';
import { formatNumberDecimal } from '../../../../Services/FormatTemplate';
import { agregarDias, setDateTimeSQLH } from '../../../../Services/FechasService'

//***********************************Componentes API********************************************** */
import { getTerminosPaymentTerms } from '../../../../API/Global/Terminos/TerminosRequest';
import { getCompany } from '../../../../API/Company/CompanyRequest';
import { getCurrencyIPS } from '../../../../API/Global/Currency/CurrencyRequest';
import { getReferencias } from '../../../../API/CuentasPorPagar/ReferenciasFacturacion/ReferenciaFacturacionRequest';
import { getCalendarioFinanzasMensualProduccion } from '../../../../API/Global/CalendarioFinanzas/CalendarioFinanzasRequest';
import { getUnidades } from '../../../../API/Global/Unidades/UnidadesRequest';
import {
    postRegistroCuentasPorPagar, getEncabezadoCuentasPorPagar, getDetallesCuentasPorPagar, postEstadoDetallesCuentasPorPagar,
    getUltimoIdEncabezadoCXP, postEliminarIngresoDeCuentasPorPagar, getDetallesIngresos, getIngresoCuentaTransito, getInformacionEncabezadoCXP,
    postEncabezadoConsolidado,
    postEncabezadoConsolidadoInv,
    postIUEncabezadoConsolidadoInv,
    getVerificacionFactura,
    getDocumentosFactura
} from '../../../../API/CuentasPorPagar/CXP/CuentasPorPagarRequest';
import { getAreasActivasIPS } from '../../../../API/Global/Areas/AreasRequest';
import { getBalancePurchaseDetail, getBalancePurchaseDetails, getPurchaseOrder } from '../../../../API/PurchaseOrders/PurchaseOrderRequest';
import { getClasificacionDeGastos } from '../../../../API/Global/ClasificacionDeGastos/ClasificacionDeGastosRequest'
import { getEstadosCategory, getEstadosCategoryIPS } from '../../../../API/Global/Estados/StatusRequest'
import { getInfoProducto } from '../../../../API/Global/ProductosSuministros/ProductosSuministrosRequest';

//**********************************Componentes Especificos****************************** */
import ProductosOverlayPanel from '../../../Productos/Productos/ComponentesProductos/ProductosOverlayPanel';
import OverlaySeleccionProveedoresCAI from '../../ProveedoresCAI/OverlaySeleccionProveedoresCAI';

import AllPurchaseOrderOverlayPanel from '../../../Compras/OverlayPanels/AllPurchaseOrderOverlayPanel'
import AllPurchaseOrderDetailsOverlayPanel from '../../../Compras/OverlayPanels/AllPurchaseOrderDetailsOverlayPanel';
import ModalProveedorCAI from '../../ProveedoresCAI/ModalProveedorCAI';
import ModalProductos from '../../../Productos/Productos/ModalProductos/ModalProductos';
//*****************************Contextos******************************************************** */
import { AuthContext } from '../../../../Context/AuthContext/AuthContext';
import { ValidarFacturaProveedor, verificarCAI } from '../../../../Utils/Funciones/FuncionesProveedores';
import { RedondearNumero, obtenerTasaCambioFinanzas } from '../../../../Utils/Funciones/Funciones';
import { getCAIsProveedor, getProveedoresCAI } from '../../../../API/Proveedores/ProveedoresRequest';
import { getLabel } from '../../../../Services/Language/LanguageService';
import { CuentasPorPagarLang } from '../Lang/CuentasPorPagarLang';
import { ConfigContext } from '../../../../Context/ConfigContext/ConfigContext';
import { InputMask } from 'primereact/inputmask';
import { getInformacionIngresosHilaza } from '../../../../../API/Inventario/InventarioHilaza/IngresosHilazaRequest';
import { InputNumber } from 'primereact/inputnumber';

import { ajusteRedondeoEquitativoJson } from '../../../../../Base/Utils/Funciones/AjusteDiferencialRedondeo';



const ModalCuentasPorPagarCompras = ({ dialogCuentas, hideDialog, IdFactura, InfoIngreso = {} }) => {
    const toast = useRef(null)
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState([])
    const [listadoDetalles, setListadoDetalles] = useState([]);
    const [showMessages, setShowMessages] = useState({ error: false });
    const [proveedores, setProveedores] = useState([]);
    const [terminos, setTerminos] = useState([]);
    const [monedas, setMonedas] = useState([]);
    const [proveedoresCAI, setProvedoresCAI] = useState([]);
    const [proveedoreCAIFiltrados, setProvedoresCAIFiltrados] = useState([]);
    const [referencias, setReferencias] = useState([]);
    const [ocultar, setOcultar] = useState(false);
    const [unidades, setUnidades] = useState([]);
    const [habilitar, setHabilitar] = useState(false);
    const [areas, setAreas] = useState([]);
    const [dialogDividir, setDialogDividir] = useState(false);
    const [habilitasPO, setHabilitarPO] = useState(false);
    const [estados, setEstados] = useState([]);
    const [accesoHabilitar, setAccesoHabilitar] = useState(true)

    const [dialogProducto, setDialogProducto] = useState(false);
    const [IdProducto, setIdProducto] = useState(0);
    const [dialogCAI, setDialogCAI] = useState(0);
    const [eliminarIngreso, setEliminarIngreso] = useState(true)
    const isFirstRender = useRef(true);

    let valoresIniciales = {
        Id: -10,
        FechaEmision: new Date(),
        FechaIngreso: new Date(),
        IdEstado: 2061,
        IdMoneda: 2,
        IdProveedor: null,
        Flete: 0,
        TasaCambioFlete: 0,
        Embalaje: 0,
        TasaCambioEmbalaje: 0,
        Desaduanaje: 0,
        TasaCambioDesaduanaje: 0,
        OtrosCostos: 0,
        TasaCambioOtros: 0,
        IsDollar: 0,
        IdLiquidacion: 0,
        IdCuenta: 15,
        IdPO: null,
        PurchaseOrder: '',
        IdReferencia: 9,
        FechaVencimiento: null,
        IdClasificacion: null,
        Documento: '',
        IsRegistroManual: true,
        MontoAdicional: 0,
        TasaCambioAdicional: 0,
        IdEstadoFinanzas: 3713,
        IdUserIngresoCompras: null,
        IdUserEditCompras: null,
        IsIngresoCompras: 1,
        OCE: '',
        MontoL: 0,
        MontoD: 0,
        CostoL: 0,
        CostoD: 0,
        PurchaseOrder: '',
        Comentario: '',
        Memo: '',
        NombreSucursal: '',
        TasaCambio: 0,
        FechaRecibidoCompras: null,
        FechaRecibidoFinanzas: null,
        FechaRevisadoFinanzas: null,
    }


    const { values, setValues, handleChange, handleInputChange, resetForm } = useForm({
        ...valoresIniciales
    });

    const { userAuth } = useContext(AuthContext);
    const { config } = useContext(ConfigContext)

    const ObtenerInformacionDropdown = async () => {
        setLoading(true)
        const tempoProveedores = await getCompany()
        setProveedores(tempoProveedores)

        const tempoProveedoresCAI = await getProveedoresCAI()
        const filCAI = tempoProveedoresCAI.filter((c) => c.IdEstado !== 7)
        setProvedoresCAI(filCAI)
        setProvedoresCAIFiltrados(filCAI)

        const tempoMonedas = await getCurrencyIPS()
        setMonedas(tempoMonedas)

        const tempoTerminos = await getTerminosPaymentTerms()
        setTerminos(tempoTerminos)

        const tempoReferencias = await getReferencias()
        setReferencias(tempoReferencias)

        const tempoUnidades = await getUnidades()
        setUnidades(tempoUnidades)

        const tempoAreas = await getAreasActivasIPS()
        setAreas(tempoAreas)

        const tempoEstados = await getEstadosCategoryIPS('Ingreso Mantenimiento Finanzas')
        setEstados(tempoEstados)

        setLoading(false)
    }

    const obtenerInformacion = async (NuevoRegistro = false) => {

        let tempoValues = { ...values }
        tempoValues.Id = NuevoRegistro ? -100 : (IdFactura || tempoValues.Id)

        if (tempoValues.Id > 0) {
            const tempoEnc = await getEncabezadoCuentasPorPagar(tempoValues.Id)
            let habilitarEdicion = false
            if (tempoEnc?.length > 0) {
                tempoValues = { ...tempoEnc[0] }
                tempoValues.FechaEmision = tempoEnc[0]?.FechaDocumento ? new Date(tempoEnc[0]?.FechaDocumento) : null
                tempoValues.FechaIngreso = tempoEnc[0]?.IncomeDate ? new Date(tempoEnc[0]?.IncomeDate) : null
                tempoValues.FechaVencimiento = tempoEnc[0]?.FechaVencido ? new Date(tempoEnc[0]?.FechaVencido) : null
                setOcultar([1, 3]?.includes(tempoEnc[0]?.IdMoneda))
                if (tempoEnc[0]?.IsRegistroManual) {
                    ObtenerDetalles(tempoValues.Id)
                } else {
                    let userAccesos = userAuth?.AccesosWeb
                    const ordenado = userAccesos.split(',').sort();
                    const accesoHabilitar = ordenado.some((item) => item === '38')
                    setAccesoHabilitar(accesoHabilitar)

                    obtenerDetallesIngreso(tempoEnc[0])
                }
                setHabilitarPO(true)

                const tempoDocumentosFaturas = await getDocumentosFactura(tempoValues.Id)

                if (tempoDocumentosFaturas?.length > 0) {
                    setEliminarIngreso(false)
                } else {

                    setEliminarIngreso((tempoValues?.ValorPagadoD > 0) ? false : tempoValues.IdEstadoFinanzas !== 3581)
                }
            }

            setHabilitar(habilitarEdicion)

        } else {

            InformacionInicial(tempoValues)
        }
        setValues(tempoValues)


    }

    const InformacionInicial = async (tempoValues) => {
        const tc = await ObtenerTasa()

        if (userAuth?.IdRol === 1036) {
            tempoValues.IdEstadoFinanzas = 3714
        }

        let HA = true
        const resultUltimo = await getUltimoIdEncabezadoCXP()
        if (resultUltimo?.length > 0) {

            let anioActual = new Date().getFullYear()
            const tempoNumero = (resultUltimo[0]?.NoIngreso).slice(5)
            let tempoId = (Number(tempoNumero) + 1)?.toString()
            let año = (anioActual?.toString())?.slice(-2)
            let NumeroCorrelativo = 0
            if (tempoId?.length <= 5 && tempoId?.length !== 0) {
                NumeroCorrelativo = tempoId.padStart(InfoIngreso?.IdPO > 0 ? 6 : 5, 0)
            }
            let IniNumero = InfoIngreso?.IdPO > 0 ? 'IH' : 'IF'
            let NumeroIngreso = IniNumero + año + '-' + NumeroCorrelativo
            tempoValues.NoIngreso = NumeroIngreso
        }
        else {

            tempoValues.NoIngreso = 'IF24' + '-00001'

        }


        if (InfoIngreso?.IdPO > 0) {
            const tempoHI = await getInformacionIngresosHilaza(InfoIngreso)
            if (tempoHI?.length > 0) {
                HA = false
                let temCantidad = tempoHI?.reduce((total, value) => total + value.QtyIngresada, 0)
                let temCostoL = RedondearNumero(tempoHI?.reduce((t, v) => t + v.CostoL, 0));
                let temCostoD = RedondearNumero(tempoHI?.reduce((t, v) => t + v.CostoD, 0));
                let temMontoL = RedondearNumero(tempoHI?.reduce((t, v) => t + v.MontoL, 0));
                let temMontoD = RedondearNumero(tempoHI?.reduce((t, v) => t + v.MontoD, 0));

                let productos = tempoHI.map((e) => {
                    return 'hilaza ' + (e.IdCategory === 1 ? 'Algodón' : 'Sintetico') + ' ' + e.NombreProducto + ' '
                })
                let Purchase = tempoHI.map((e) => {
                    return e.PurchaseOrder
                })

                let po = [...new Set(Purchase)].join(',')

                let p = productos?.join(', ')

                let memoG = `US$ ${formatNumberDecimal(temCostoD)} Compra de ${formatNumberDecimal(temCantidad)} kg de ${p}, ${po}`


                let detalles = tempoHI.map((t) => {

                    let memo = `US$ ${formatNumberDecimal(t.CostoD)} Compra de ${formatNumberDecimal(t.QtyIngresada)} kg de hilaza ${t.IdCategory === 1 ? 'Algodón' : 'Sintetico'} ${t.NombreProducto} 
                    ${t.PurchaseOrder} Ingreso: ${t.OrdenIngreso}`

                    return {
                        ...t,
                        Memo: memo,
                        MemoGeneral: memoG,
                        MemoDet: memo
                    }
                })
                let infoDet = tempoHI[0]

                tempoValues = {
                    ...tempoValues,
                    Id: -100,
                    IdPO: infoDet?.IdPO,
                    PurchaseOrder: infoDet?.PurchaseOrder,
                    IdProveedor: infoDet?.IdProveedor,
                    Proveedor: infoDet?.Proveedor,
                    Documento: infoDet?.Documento,
                    FechaEmision: infoDet?.FechaFactura ? new Date(infoDet?.FechaFactura) : null,
                    FechaIngreso: infoDet?.FechaRecibida ? new Date(infoDet?.FechaRecibida) : null,
                    FechaVencimiento: infoDet?.FechaVencimiento ? new Date(infoDet?.FechaVencimiento) : null,
                    IdTerms: infoDet?.TerminoPago,
                    IdMoneda: 1,
                    IdClasificacion: 1,
                    IdReferencia: 5,
                    TasaCambio: infoDet?.TasaCambio > 0 ? infoDet?.TasaCambio : tc,
                    MontoL: temMontoL,
                    MontoD: temMontoD,
                    CostoL: temCostoL,
                    CostoD: temCostoD,
                    Comentario: memoG,
                    Memo: memoG,
                    IsRegistroManual: false,
                    IdCuenta: infoDet?.IdCountry !== 95 ? 16 : 15,
                    IdEstadoFinanzas: infoDet?.IdEstadoFinanzas
                }


                let userAccesos = userAuth?.AccesosWeb
                const ordenado = userAccesos.split(',').sort();
                const accesoHabilitar = ordenado.some((item) => item === '38')
                setAccesoHabilitar(accesoHabilitar)

                setHabilitarPO(true)
                setListadoDetalles(detalles)
                setValues(tempoValues)
            }
        } else {
            tempoValues.TasaCambio = tc
            setValues(tempoValues)
        }
        setHabilitar(HA)
    }



    const ObtenerDetalles = async (Id) => {
        setLoading(true)

        const tempoDetalles = await getDetallesCuentasPorPagar(Id)
        setListadoDetalles(tempoDetalles)
        setLoading(false)
    }

    const obtenerDetallesIngreso = async (enc) => {
        if (enc) {
            const informacion = {
                IdReferencia: enc?.IdReferencia,
                IdIngresoReferencia: enc?.IdIngresoReferencia,
                IdProveedor: enc?.IdProveedor,
                NumeroReferencia: enc?.NumeroReferencia,
                IdCXP: enc?.Id
            }
            const result = await getDetallesIngresos(informacion)
            setListadoDetalles(result)

        }
    }


    const NuevaFila = (informacioPO, values, e = {}, pd = null) => {

        let newRow = [...listadoDetalles]

        let idExiste = listadoDetalles.some((l) => informacioPO.some((i) => i.IdPurchaseOrderDetail === l.IdPurchaseOrderDetail))

        if (!idExiste) {
            let dataNueva = informacioPO.map((i, index) => {
                let IdAleatorio = (listadoDetalles?.length + index + 1) * (-1)
                let ExisteID = listadoDetalles.find((l) => l.IdDetalle === IdAleatorio)


                let precioL = i.QtyOrdered > 0 ? (i.IdCurrency === 2 ? 1 : values.TasaCambio) * (i.Total / i.QtyOrdered) : 0
                let precioD = i.QtyOrdered > 0 ? ((i.Total / i.QtyOrdered) / (i.IdCurrency === 2 ? values.TasaCambio : 1)) : 0

                let isvL = i.IdCurrency === 2 ? i.ISV : i.ISV * values.TasaCambio
                let isvD = i.IdCurrency === 1 || i.IdCurrency === 3 ? i.ISV : i.ISV / values.TasaCambio

                let descuentoL = i.IdCurrency === 2 ? i.Descuento : i.Descuento * values.TasaCambio
                let descuentoD = i.IdCurrency === 1 || i.IdCurrency === 3 ? i.Descuento : i.Descuento / values.TasaCambio


                return {
                    IdDetalle: ExisteID ? IdAleatorio * 3 : IdAleatorio,
                    IdEncabezado: values.Id,
                    IdProducto: i.IdComponent,
                    NombreProducto: i.NombreProducto,
                    CodigoProducto: i.CodigoProducto,
                    IdSubCategoriaFinanzas: i.IdSubCategoriaFinanzas,
                    IdCategoriaFinanzas: i.IdCategoriaFinanzas,
                    CategoriaFinanzas: i.CategoriaFinanzas,
                    SubCategoriaFinanzas: i.SubCategoriaFinanzas,

                    IdPurchaseOrder: i.IdPurchaseOrder,
                    PurchaseOrder: i.PurchaseOrder,

                    IdPurchaseOrderDetail: i.IdPurchaseOrderDetail,
                    IdUnit: i.IdUnit,
                    UnitName: i.UnitName,



                    Cantidad: i.BalancePOD,
                    IdMoneda: values.IdMoneda,
                    TasaCambio: values.TasaCambio,

                    PrecioL: precioL,
                    SubTotalL: precioL * i.BalancePOD,
                    ISVL: isvL,
                    MontoL: (precioL * i.BalancePOD),
                    PrecioLiquidacionL: precioL,
                    CostoL: (precioL * i.BalancePOD),
                    DescuentoL: descuentoL,

                    PrecioD: precioD,
                    SubTotalD: precioD * i.BalancePOD,
                    ISVD: isvD,
                    MontoD: (precioD * i.BalancePOD),
                    PrecioLiquidacionD: precioD,
                    CostoD: (precioD * i.BalancePOD),
                    DescuentoD: descuentoD,



                    IdUserIngreso: userAuth.idUser,
                    IdEstado: 2061,
                    FechaCreado: getDateTimeStringSQL(new Date()),
                    IdUserEdit: userAuth.idUser,
                    FechaEdit: getDateTimeStringSQL(new Date()),

                    QtyOrdered: i.QtyOrdered,
                    QtyReceive: i.QtyReceive,
                    QtyReserved: i.QtyReserved,
                    BalanceOrden: i.QtyOrdered - (i.QtyReceive + i.QtyReserved),
                    Balance: i.QtyOrdered - (i.QtyReceive + i.QtyReserved),

                    IdArea: i?.IdAreaPersonal ? i?.IdAreaPersonal : i.IdArea,
                    Area: i?.AreaPersonal ? i?.AreaPersonal : i.AreaSolicita,
                    // IdArea: null, //i.IdAreaPO,
                    // Area: null, //i.AreaPO
                    IdConstruccion: null,
                    NombreConstruccion: null,
                    ComentarioPOD: i?.CommentPOD,
                    MemoDet: i?.MemoDet,
                    AplicaISV: false,
                    IsExento: false

                }
            })

            let nuevoArreglo = listadoDetalles.concat(dataNueva)
            let fields = ['MontoL', 'MontoD', 'CostoL', 'CostoD', 'ISVL', 'ISVD']
            let detalles = ajusteRedondeoEquitativoJson(nuevoArreglo, fields);

            // console.log(detalles, detalles.reduce((acc, val) => acc + val.MontoL, 0));

            setListadoDetalles(detalles)
            AsignarMontos(detalles, values)
            if (e && pd) {
                pd?.current?.toggle(e)
            }

        } else {
            toastShow(toast, 'error', 'No se aceptan Productos repetidos de misma Orden de Compra')
        }





    }


    const AsignarMontos = (detalles, values) => {
        let montoL = Number((detalles.reduce((t, v) => t + v.MontoL, 0)).toFixed(2))
        let montoD = Number((detalles.reduce((t, v) => t + v.MontoD, 0)).toFixed(2))

        let costoD = Number((detalles.reduce((t, v) => t + v.CostoD, 0)).toFixed(2))
        let costoL = Number((detalles.reduce((t, v) => t + v.CostoL, 0)).toFixed(2))


        let tempoValues = { ...values }
        tempoValues.MontoL = montoL
        tempoValues.MontoD = montoD
        tempoValues.CostoL = costoL
        tempoValues.CostoD = costoD
        setValues(tempoValues)
    }

    const NuevaFilaVacia = () => {
        let dataNueva = []
        let IdAleatorio = (listadoDetalles?.length + 1) * (-1)
        dataNueva.push({
            IdDetalle: IdAleatorio,
            IdEncabezado: values.Id,
            IdUserIngreso: userAuth.idUser,
            IdProducto: null,
            CodigoProducto: null,
            NombreProducto: '',
            IdPurchaseOrder: null,
            PurchaseOrder: null,
            IdPurchaseOrderDetail: null,
            IdUnit: null,
            UnitName: '',
            IdCuentaFinanzas: null,
            IsDobleCuenta: null,
            IdCuentaAlgodon: null,
            IdCuentaSintetico: null,
            Cantidad: 0,
            IdMoneda: values.IdMoneda,
            TasaCambio: values.TasaCambio,
            PrecioL: 0,
            SubTotalL: 0,
            ISVL: 0,
            MontoL: 0,
            PrecioD: 0,
            SubTotalD: 0,
            ISVD: 0,
            MontoD: 0,
            IdEstado: 2061,
            FechaCreado: getDateTimeStringSQL(new Date()),
            IdUserEdit: userAuth.idUser,
            FechaEdit: getDateTimeStringSQL(new Date()),
            QtyOrdered: 0,
            QtyRecieve: 0,
            BalanceOrden: 0,
            IdArea: null,
            IdConstruccion: null,
            NombreConstruccion: null,
            QtyReserved: 0,
            ComentarioPOD: '',
            MemoDet: '',
            DescuentoD: 0,
            DescuentoL: 0

        })

        let nuevoArreglo = listadoDetalles.concat(dataNueva)
        setListadoDetalles(nuevoArreglo)
    }

    const RemoverFilas = async () => {
        if (selected?.length > 0) {

            let listadoFinal = listadoDetalles.filter((l) => !selected.some((s) => s.IdDetalle === l.IdDetalle))
            let detallesEnviar = selected.filter((i) => i.IdDetalle > 0).map((s) => {
                return {
                    IdDetalle: s.IdDetalle,
                    IdEstado: 2063,
                    IdUserEdit: userAuth.idUser,
                    IdEncabezado: s.IdEncabezado,
                    IdPurchaseOrderDetail: s.IdPurchaseOrderDetail,
                    Cantidad: s.Cantidad,
                    IdUserEditCompras: userAuth.idUser
                }
            })

            if (detallesEnviar?.length > 0) {
                const result = await postEstadoDetallesCuentasPorPagar(detallesEnviar)
                if (result) {
                    setListadoDetalles(listadoFinal)
                    AsignarMontos(listadoFinal, values)
                    if (listadoFinal?.length === 0) {
                        setHabilitarPO(false)
                    }

                } else {
                    toastShow(toast, 'error', 'Ocurrio un error al remover las filas')
                }
            } else {

                setListadoDetalles(listadoFinal)
                AsignarMontos(listadoFinal, values)
                if (listadoFinal.length === 0) {
                    setHabilitarPO(false)
                }
            }
        } else {
            toastShow(toast, 'error', 'Debe seleccionar las filas que desea remover')
        }
        setSelected([])
    }

    const changeProducto = ({ data }) => {
        return <ProductosOverlayPanel
            rowData={data}
            onChange={({ api, data }, rowData) => {
                const index = listadoDetalles.findIndex(detail => detail.IdDetalle === rowData.IdDetalle);
                let newDetail = [...listadoDetalles];
                newDetail[index].IdProducto = data.IdProductoSuministro;
                newDetail[index].CodigoProducto = data.Codigo
                newDetail[index].NombreProducto = data.Producto;
                newDetail[index].IdUnit = data.IdUnit;
                newDetail[index].UnitName = data.Unidad;
                newDetail[index].IdCategoriaFinanzas = data.IdCategoriaFinanzas
                newDetail[index].CategoriaFinanzas = data.CategoriaFinanzas
                newDetail[index].IdSubCategoriaFinanzas = data.IdSubCategoriaFinanzas
                newDetail[index].SubCategoriaFinanzas = data.SubCategoriaFinanzas
                setListadoDetalles(newDetail);
                api.stopEditing();
            }}
        />

    }

    const AsignarInformacion = (detalle) => {
        let tempoValues = { ...values }
        detalle.PrecioLiquidacionL = detalle.PrecioL
        detalle.CostoL = detalle.MontoL - detalle.ISVL

        detalle.PrecioLiquidacionD = detalle.PrecioD
        detalle.CostoD = detalle.MontoD - detalle.ISVD

        detalle.SubTotalD = (detalle.PrecioLiquidacionD * detalle.Cantidad)
        detalle.SubTotalL = (detalle.PrecioLiquidacionL * detalle.Cantidad)

        let tempo = [...listadoDetalles]
        let index = tempo.findIndex((t) => t.IdDetalle === detalle.IdDetalle)
        tempo[index] = detalle


        AsignarMontos(tempo, tempoValues)
        setListadoDetalles(tempo)

    }

    const AsignarCantidad = async (data, detalle) => {
        const index = listadoDetalles.findIndex(detail => detail.IdDetalle === detalle.IdDetalle);
        let newDetail = [...listadoDetalles];
        let Qty
        if (detalle.IdDetalle < 0) {
            // Qty = Number(data.newValue) + detalle.QtyReceive
            Qty = Number(data.newValue) + (detalle.QtyReceive + detalle.QtyReserved)
            if (detalle.IdPurchaseOrderDetail > 0 && Qty > detalle.QtyOrdered) {
                toastShow(toast, 'error', 'El producto no tiene balance suficiente para esa cantidad')
                newDetail[index].Cantidad = data.oldValue
                detalle.Cantidad = data.oldValue
            } else {
                detalle.Cantidad = Number(data.newValue)
                detalle.Balance = detalle.QtyOrdered - Qty
            }
        } else {
            Qty = Number(data.newValue)
            const result = await getBalancePurchaseDetail(detalle.IdDetalle, detalle.IdPurchaseOrderDetail)
            if (result?.length > 0) {
                let tempoPOD = result[0]
                if (Qty > tempoPOD?.Balance) {
                    toastShow(toast, 'error', 'La cantidad ingresada supera el balance del producto')
                    newDetail[index].Cantidad = data.oldValue
                    detalle.Cantidad = data.oldValue
                }
            } else {
                if (detalle.IdPurchaseOrderDetail > 0 && Qty > detalle.QtyOrdered) {
                    toastShow(toast, 'error', 'La cantidad es mayor a la que se ordeno')
                    detalle.Cantidad = data.oldValue
                    newDetail[index].Cantidad = data.oldValue
                }
            }

        }
        if (values.IdMoneda !== 2) {
            detalle.SubTotalD = detalle.Cantidad * detalle.PrecioD
            detalle.SubTotalL = RedondearNumero(detalle.SubTotalD * values.TasaCambio)
            detalle.MontoD = RedondearNumero((detalle.PrecioD * detalle.Cantidad) + detalle.ISVD)
            detalle.MontoL = RedondearNumero(detalle.MontoD * values.TasaCambio)
        } else {
            detalle.SubTotalL = RedondearNumero(detalle.Cantidad * detalle.PrecioL)
            detalle.SubTotalD = RedondearNumero(detalle.SubTotalL / values.TasaCambio)
            detalle.MontoL = RedondearNumero((detalle.PrecioL * detalle.Cantidad) + detalle.ISVL)
            detalle.MontoD = RedondearNumero(detalle.MontoL / values.TasaCambio)
        }
        // setListadoDetalles(newDetail)
        AsignarInformacion(detalle)
        Calcular(values)


    }

    const OpenProducto = (Id) => {
        setDialogProducto(true)
        setIdProducto(Id)
    }

    const hideDialogProducto = () => {
        setDialogProducto(false)
        AsignarCategoriaProducto()
    }

    const AsignarCategoriaProducto = async () => {
        if (IdProducto > 0) {
            const tempoProducto = await getInfoProducto(IdProducto)
            if (tempoProducto?.length > 0) {
                let producto = tempoProducto[0]
                let tempo = [...listadoDetalles]

                let tempoRows = listadoDetalles.filter((f) => f.IdProducto === IdProducto)
                tempoRows.forEach((l) => {
                    const index = listadoDetalles.findIndex(detail => detail.IdDetalle === l.IdDetalle);

                    tempo[index].IdCategoriaFinanzas = producto?.IdCategoriaFinanzas
                    tempo[index].CategoriaFinanzas = producto?.CategoriaFinanzas
                    tempo[index].IdSubCategoriaFinanzas = producto?.IdSubCategoriaFinanzas
                    tempo[index].SubCategoriaFinanzas = producto?.SubCategoriaFinanzas
                });


                setListadoDetalles(tempo);

            }


        }
    }

    const TemplateArea = ({ data, oldValue, api }, column) => {
        return <Dropdown
            value={data?.IdArea}
            options={areas}
            optionValue='IdArea'
            optionLabel='Area'
            filter filterBy='Area'
            style={{ width: '100%' }}
            onChange={(e) => {
                const tempoArea = areas.find((c) => c.IdArea === e?.value)
                let tempo = [...listadoDetalles]
                let d = data

                if (tempoArea) {
                    if (selected?.length > 0) {
                        tempo.forEach((t) => {
                            selected.forEach(s => {
                                if (t.IdDetalle === s.IdDetalle) {
                                    s.IdArea = tempoArea?.IdArea
                                    s.Area = tempoArea?.Area
                                }
                            })
                        });
                    }

                    if (d?.IdDetalle) {
                        d.IdArea = tempoArea?.IdArea
                        d.Area = tempoArea?.Area
                        const index = listadoDetalles.findIndex(detail => detail.IdDetalle === d.IdDetalle)
                        tempo[index] = d
                    }
                } else {
                    d.IdArea = null
                    d.Area = null

                    const index = listadoDetalles.findIndex(detail => detail.IdDetalle === d.IdDetalle)
                    tempo[index] = d
                }
                setSelected([])
                setListadoDetalles(tempo)
            }}
        />
    }

    const table = {
        Data: listadoDetalles,
        selected: selected,
        setSelected: setSelected,
        Columns: [
            {
                field: 'IdDetalle',
                header: 'IdDetalle',
                headerEn: 'IdDetalle',
                className: 'XXsmall',
                hidden: userAuth.IdRol === 1,
                frozen: true,
                alignFrozen: 'left',
            },
            {
                field: 'CodigoProducto',
                header: 'Codigo',
                headerEn: 'Code',
                className: 'small',
                // onCellDoubleClicked: (({ data }) => {
                //     if (data.IdProducto) {
                //         OpenProducto(data.IdProducto)
                //     }
                // }),
                frozen: true,
                alignFrozen: 'left',
            },
            {
                field: 'NombreProducto',
                header: 'Producto',
                headerEn: 'Product',
                className: 'XXlarge',
                Sumary: 'count',

                editable: ({ data }) => {
                    if (values.IsRegistroManual) {
                        if (!data.IdPurchaseOrderDetail && habilitar)
                            return true
                        return false
                    }

                },
                cellEditor: changeProducto,
                frozen: true,
                alignFrozen: 'left',
                // onCellDoubleClicked: (({ data }) => {
                //     if (data.IdProducto) {
                //         OpenProducto(data.IdProducto)
                //     }
                // })
            },
            {
                field: 'ComentarioPOD',
                header: 'Comentario POD',
                headerEn: 'Comentario POD',
                className: '',
            },


            {
                field: 'Area',
                header: 'Area',
                headerEn: 'Area',
                className: 'XXlarge',
                editable: ({ data }) => {
                    if (values.IsRegistroManual) {
                        if (values.IdStatus !== 1021 && habilitar)
                            return true
                        return false
                    }

                },
                cellEditor: TemplateArea

            },
            {
                field: 'CategoriaFinanzas',
                header: 'Categoria Finanzas',
                headerEn: 'Categoria Finanzas',
                className: 'large',
            },
            {
                field: 'SubCategoriaFinanzas',
                header: 'Sub Categoria Finanzas',
                headerEn: 'SubcCategoria Finanzas',
                className: 'large',
            },

            {
                field: 'PurchaseOrder',
                header: 'PO',
                headerEn: 'Purchase order',
                className: 'Xsmall',
                // onCellDoubleClicked: ({ data }) => {

                //     if (data.PurchaseOrder) {
                //         window.open(`${process.env.REACT_APP_ENV}/OrdenesCompra/${data.PurchaseOrder}`, data.PurchaseOrder, 'height=800,width=1450')
                //     }
                // }
            },
            {
                field: 'MemoDet',
                header: 'Descripcion',
                headerEn: 'Memo',
                className: 'XXXlarge',
                editable: ({ data }) => {

                    if (values.IsRegistroManual) {
                        if (values.IdStatus !== 1021 && habilitar)
                            return true
                        return false
                    }
                },
            },
            {
                field: 'UnitName',
                header: 'Unidad',
                headerEn: 'Unit',
                className: 'Xsmall',
                width: 80,
                editable: values.IsRegistroManual ? habilitar : false,
                Format: 'AutoComplete',
                value: 'IdUnit',
                label: 'UnitName',
                items: unidades,
            },
            {
                field: 'IsExento',
                header: 'IsExento',
                className: 'Xsmall',
                Format: 'Checkbox',
                Frozen: true,
                alignFrozen: 'right',
                filter: true,
                tooltip: ({ data }) => {
                    if (habilitar) {
                        if (data?.ISVD <= 0 || data.ISVL <= 0) {
                            if (values.IdStatus !== 1021 && habilitar && !data.IdConstruccion)
                                return ''
                            return ''
                        } else {
                            return 'El producto tiene ISV'
                        }
                    } else {
                        return ''
                    }
                },
                onChange: (e, rowData) => {
                    let detalle = { ...rowData.data }
                    let tempo = [...listadoDetalles]


                    setLoading(true)
                    if (selected.length > 0) {
                        let rowsValidos = selected.filter((sf) => sf.ISVD === 0 && sf.ISVL === 0)
                        tempo.forEach((t) => {
                            rowsValidos.forEach((s) => {
                                if (t.IdDetalle === s.IdDetalle) {
                                    s.IsExento = !s.IsExento
                                }
                            })
                        })
                    } else {
                        detalle.IsExento = !detalle.IsExento
                        const index = tempo.findIndex(detail => detail.IdDetalle === detalle.IdDetalle)
                        tempo[index] = detalle
                    }


                    let tempoValues = { ...values }
                    let detExento = tempo.filter((t) => t.IsExento)

                    if (detExento.length !== tempo.length) {
                        if (!tempoValues.OCE || ((tempoValues.OCE)?.trim())?.length === 0) {
                            let anio = new Date().getFullYear()
                            tempoValues.OCE = 'OC' + anio
                        }
                    } else {
                        if (((tempoValues.OCE)?.trim())?.length > 0) {
                            tempoValues.OCE = ''
                        }
                    }
                    setValues(tempoValues)
                    setListadoDetalles(tempo)
                    setSelected([])
                    setLoading(false)
                    // CuentaDoble(rowData.value, rowData.data)
                },
                Disabled: ({ data }) => {
                    if (data?.ISVD <= 0 || data.ISVL <= 0) {
                        if (values.IdStatus !== 1021 && habilitar && !data.IdConstruccion)
                            return true
                        return false
                    } else {
                        return false
                    }
                }
            },
            {
                field: 'Cantidad',
                header: 'Cantidad',
                headerEn: 'Quantity',
                className: 'Xsmall',
                Format: 'Currency',
                Sumary: 'sum',
                editable: values.IsRegistroManual ? habilitar : false,
                Frozen: true,
                alignFrozen: 'right',
                onChange: (data) => {
                    if (data.newValue || data.newValue === 0) {
                        let detalle = data.data

                        if (detalle.IdPurchaseOrderDetail > 0) {
                            AsignarCantidad(data, detalle)
                        } else {
                            detalle.Cantidad = Number(data.newValue)
                            detalle.SubTotalL = detalle.Cantidad * detalle.PrecioL
                            detalle.SubTotalD = detalle.Cantidad * detalle.PrecioD
                            detalle.MontoL = RedondearNumero((((detalle.PrecioL * detalle.Cantidad) + detalle.ISVL) - detalle.DescuentoL), 2)
                            detalle.MontoD = RedondearNumero((((detalle.PrecioD * detalle.Cantidad) + detalle.ISVD) - detalle.DescuentoD), 2)
                            AsignarInformacion(detalle)
                            Calcular(values)

                        }
                        // Calcular()



                    }
                }
            },
            {

                headerName: 'Lempiras',

                children: [
                    {
                        field: 'DescuentoL',
                        header: 'DescuentoL',
                        headerEn: 'DescuentoL',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Sumary: 'sum',
                        hidden: !ocultar,
                        editable: values.IsRegistroManual ? habilitar : false,
                        Frozen: true,
                        alignFrozen: 'right',
                        onChange: (data) => {
                            if (data.newValue || data.newValue === 0) {
                                let detalle = data.data
                                detalle.DescuentoL = Number(data.newValue)
                                detalle.DescuentoD = detalle.DescuentoL / values.TasaCambio
                                detalle.MontoL = RedondearNumero((((detalle.PrecioL * detalle.Cantidad) + detalle.ISVL) - detalle.DescuentoL), 2)
                                detalle.MontoD = RedondearNumero((((detalle.PrecioD * detalle.Cantidad) + detalle.ISVD) - detalle.DescuentoD), 2)

                                detalle.IdMoneda = values.IdMoneda
                                AsignarInformacion(detalle)
                                // setListadoDetalles(tempo)
                            }
                        }
                    },

                    {
                        field: 'PrecioL',
                        header: 'Precio L',
                        headerEn: 'Price L',
                        className: 'Xsmall',
                        Format: 'Currency',
                        hidden: !ocultar,
                        editable: ({ data }) => {
                            return userAuth.IdRol === 1 || (values.IsRegistroManual ? (!data?.IdPurchaseOrderDetail && habilitar) : false)
                        },
                        // editable: userAuth.IdRol === 1 ,
                        Frozen: true,
                        alignFrozen: 'right',

                        onChange: (data) => {
                            if (data.newValue || data.newValue === 0) {
                                let detalle = data.data
                                // detalle.PrecioL = Number(data.newValue)
                                // detalle.MontoL = RedondearNumero((((detalle.PrecioL * detalle.Cantidad) + detalle.ISVL) - detalle.DescuentoL), 2)
                                // detalle.PrecioLiquidacionL = detalle.PrecioL
                                // detalle.CostoL = detalle.MontoL

                                // detalle.PrecioD = detalle.PrecioL / values.TasaCambio
                                // detalle.MontoD = RedondearNumero((((detalle.PrecioD * detalle.Cantidad) + detalle.ISVD) - detalle.DescuentoD), 2)

                                // detalle.PrecioLiquidacionD = detalle.PrecioD
                                // detalle.CostoD = detalle.MontoD

                                // detalle.IdMoneda = values.IdMoneda

                                detalle.PrecioL = Number(data.newValue)
                                detalle.MontoL = RedondearNumero((((detalle.PrecioL * detalle.Cantidad) + detalle.ISVL) - detalle.DescuentoL), 2)
                                detalle.PrecioLiquidacionL = detalle.PrecioL
                                detalle.CostoL = detalle.MontoL

                                detalle.MontoD = values.TasaCambio > 0 ? RedondearNumero(((detalle.PrecioL * detalle.Cantidad) / (values.TasaCambio > 0 ? values.TasaCambio : 0)) + detalle.ISVD - detalle.DescuentoD) : 0
                                detalle.PrecioD = RedondearNumero(((detalle.MontoD - detalle.ISVD) / detalle.Cantidad), 6)
                                detalle.PrecioLiquidacionD = detalle.PrecioD
                                detalle.CostoD = detalle.MontoD

                                detalle.IdMoneda = values.IdMoneda

                                AsignarInformacion(detalle)



                            }
                        }

                    },
                    {
                        field: 'ISVL',
                        header: 'ISV L',
                        headerEn: 'ISV L',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Sumary: 'sum',
                        hidden: !ocultar,
                        // editable: values.IsRegistroManual ? habilitar : false,
                        editable: ({ data }) => {
                            if (values.IsRegistroManual ? habilitar : false)
                                if (!data.IsExento)
                                    return true
                            return false
                        },
                        Frozen: true,
                        alignFrozen: 'right',
                        onChange: (data) => {
                            if (data.newValue || data.newValue === 0) {
                                let detalle = data.data
                                detalle.ISVL = Number(data.newValue)
                                detalle.ISVD = RedondearNumero(detalle.ISVL / values.TasaCambio)
                                detalle.MontoL = RedondearNumero((((detalle.PrecioL * detalle.Cantidad) + detalle.ISVL) - detalle.DescuentoL), 2)
                                detalle.MontoD = RedondearNumero(((((detalle.PrecioL * detalle.Cantidad) / (values.TasaCambio > 0 ? values.TasaCambio : 1)) + detalle.ISVD) - detalle.DescuentoD), 2)
                                detalle.IdMoneda = values.IdMoneda

                                AsignarInformacion(detalle)

                            }
                        }
                    },
                    {
                        field: 'MontoL',
                        header: 'Monto L',
                        headerEn: 'Amount L',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Sumary: 'sum',
                        hidden: !ocultar,
                        editable: values.IsRegistroManual ? habilitar : false,
                        Frozen: true,
                        alignFrozen: 'right',
                        onChange: (data) => {

                            if (data.newValue || data.newValue === 0) {
                                let detalle = data.data
                                detalle.MontoL = data.newValue
                                detalle.MontoD = values.TasaCambio > 0 ? RedondearNumero(data.newValue / values.TasaCambio) : 0
                                detalle.PrecioL = detalle.Cantidad > 0 ? detalle.MontoL / detalle.Cantidad : detalle.MontoL
                                detalle.PrecioD = detalle.Cantidad > 0 ? detalle.MontoD / detalle.Cantidad : detalle.MontoD

                                AsignarInformacion(detalle)
                                // AsignarMontos(tempo, { ...values })
                                // Calcular(values)

                            }
                        }
                        // hidden: !ocultar,
                    },



                ]
            },

            {

                headerName: 'Dolares',

                children: [

                    {
                        field: 'DescuentoD',
                        header: 'Descuento $',
                        headerEn: 'Descuento $',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Sumary: 'sum',
                        hidden: ocultar,
                        editable: values.IsRegistroManual ? habilitar : false,
                        Frozen: true,
                        alignFrozen: 'right',
                        onChange: (data) => {
                            if (data.newValue || data.newValue === 0) {
                                let detalle = data.data
                                detalle.DescuentoD = Number(data.newValue)
                                detalle.DescuentoL = detalle.DescuentoD * values.TasaCambio

                                detalle.MontoL = RedondearNumero((((detalle.PrecioL * detalle.Cantidad) + detalle.ISVL) - detalle.DescuentoL), 2)
                                detalle.MontoD = RedondearNumero((((detalle.PrecioD * detalle.Cantidad) + detalle.ISVD) - detalle.DescuentoD), 2)
                                detalle.IdMoneda = values.IdMoneda

                                AsignarInformacion(detalle)

                            }
                        }
                    },
                    {
                        field: 'PrecioD',
                        header: 'Precio $',
                        headerEn: 'Price $',
                        className: 'Xsmall',
                        Format: 'Currency',
                        hidden: ocultar,
                        editable: ({ data }) => {
                            return userAuth.IdRol === 1 || (values.IsRegistroManual ? (!data?.IdPurchaseOrderDetail && habilitar) : false)
                        },
                        Frozen: true,
                        alignFrozen: 'right',

                        onChange: (data) => {
                            if (data.newValue || data.newValue === 0) {
                                let detalle = data.data
                                detalle.PrecioD = Number(data.newValue)
                                detalle.MontoD = RedondearNumero((((detalle.PrecioD * detalle.Cantidad) + detalle.ISVD) - detalle.DescuentoD), 2)
                                detalle.MontoL = RedondearNumero(((detalle.PrecioD * detalle.Cantidad) * values.TasaCambio) + detalle.ISVL - detalle.DescuentoL)
                                detalle.PrecioL = detalle.Cantidad > 0 ? RedondearNumero(((detalle.MontoL - detalle.ISVL) / detalle.Cantidad), 6) : (detalle.MontoL - detalle.ISVL)

                                // detalle.MontoL = RedondearNumero((((detalle.PrecioL * detalle.Cantidad) + detalle.ISVL) - detalle.DescuentoL), 2)
                                // detalle.PrecioL = detalle.PrecioD * values.TasaCambio

                                detalle.IdMoneda = values.IdMoneda
                                AsignarInformacion(detalle)
                            }
                        }
                    },
                    {
                        field: 'ISVD',
                        header: 'ISV $',
                        headerEn: 'ISV $',
                        className: 'Xsmall',
                        Format: 'Currency',
                        // editable: values.IsRegistroManual ? habilitar : false,
                        editable: ({ data }) => {
                            if (values.IsRegistroManual ? habilitar : false)
                                if (!data.IsExento)
                                    return true
                            return false
                        },
                        Sumary: 'sum',
                        Frozen: true,
                        alignFrozen: 'right',
                        hidden: ocultar,
                        // Frozen: true,
                        // alignFrozen: 'right',
                        onChange: (data) => {

                            if (data.newValue || data.newValue === 0) {

                                let detalle = data.data
                                detalle.ISVD = Number(data.newValue)
                                detalle.MontoD = RedondearNumero((((detalle.PrecioD * detalle.Cantidad) + detalle.ISVD) - detalle.DescuentoD), 2)

                                detalle.ISVL = RedondearNumero(detalle.ISVD * values.TasaCambio)

                                detalle.MontoL = RedondearNumero((((detalle.PrecioD * detalle.Cantidad) * values.TasaCambio) + detalle.ISVL) - detalle.DescuentoL)
                                detalle.IdMoneda = values.IdMoneda

                                AsignarInformacion(detalle)
                            }
                        }
                    },
                    {
                        field: 'MontoD',
                        header: 'Monto $',
                        headerEn: 'Amount $',
                        className: 'Xsmall',
                        Format: 'Currency',
                        hidden: ocultar,
                        Sumary: 'sum',
                        editable: values.IsRegistroManual ?? habilitar,
                        Frozen: true,
                        alignFrozen: 'right',
                        onChange: (data) => {

                            if (data.newValue || data.newValue === 0) {
                                let detalle = data.data
                                detalle.MontoD = data.newValue
                                detalle.MontoL = RedondearNumero(data.newValue * values.TasaCambio)

                                detalle.PrecioL = detalle.Cantidad > 0 ? detalle.MontoL / detalle.Cantidad : detalle.MontoL
                                detalle.PrecioD = detalle.Cantidad > 0 ? detalle.MontoD / detalle.Cantidad : detalle.MontoD

                                AsignarInformacion(detalle)

                            }
                        }

                    },


                ]
            },


            {

                headerName: 'Lempiras',

                children: [
                    {
                        field: 'PrecioLiquidacionL',
                        header: 'Precio U Lps',
                        headerEn: 'Price U Lps',
                        className: 'Xsmall',
                        Format: 'Currency',
                        hidden: userAuth.IdRol === 1,
                        editable: userAuth.IdRol === 1,

                        onChange: (data) => {
                            if (data.newValue || data.newValue === 0) {
                                let detalle = data.data
                                detalle.PrecioLiquidacionL = Number(data.newValue)
                                detalle.SubTotalL = detalle.Cantidad * detalle.PrecioLiquidacionL
                                detalle.CostoL = RedondearNumero(((detalle.PrecioLiquidacionL * detalle.Cantidad) + detalle.ISVL), 2)

                                detalle.SubTotalD = detalle.Cantidad * detalle.PrecioD
                                detalle.PrecioLiquidacionD = detalle.PrecioLiquidacionL / values.TasaCambio
                                detalle.CostoD = RedondearNumero(((detalle.PrecioLiquidacionD * detalle.Cantidad) + detalle.ISVD), 2)

                                detalle.IdMoneda = values.IdMoneda

                                let tempo = [...listadoDetalles]
                                let index = tempo.findIndex((t) => t.IdDetalle === detalle.IdDetalle)
                                tempo[index] = detalle


                                setListadoDetalles(tempo)
                                AsignarMontos(tempo, { ...values })
                            }
                        }
                    },
                    // {
                    //     field: 'SubTotalL',
                    //     header: 'SubTotalL',
                    //     headerEn: 'SubTotalL',
                    //     className: 'small',
                    //     // hidden: !ocultar,
                    //     Format: 'Currency',
                    //     Sumary: 'sum',
                    //     Frozen: true,
                    //     alignFrozen: 'right',
                    // },

                    {
                        field: 'CostoL',
                        header: 'Costo L',
                        headerEn: 'Cost L',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Sumary: 'sum',
                        hidden: userAuth.IdRol === 1,
                        editable: userAuth.IdRol === 1,
                        // hidden: !ocultar,

                        onChange: (data) => {

                            if (data.newValue || data.newValue === 0) {
                                let detalle = data.data
                                detalle.CostoL = data.newValue
                                detalle.CostoD = values.TasaCambio > 0 ? RedondearNumero(data.newValue / values.TasaCambio) : 0

                                detalle.PrecioLiquidacionD = detalle.Cantidad > 0 ? detalle.CostoD / detalle.Cantidad : detalle.CostoD
                                detalle.PrecioLiquidacionL = detalle.Cantidad > 0 ? detalle.CostoL / detalle.Cantidad : detalle.CostoL

                                let tempo = [...listadoDetalles]
                                let index = tempo.findIndex((t) => t.IdDetalle === detalle.IdDetalle)
                                tempo[index] = detalle
                                setListadoDetalles(tempo)
                                AsignarMontos(tempo, { ...values })

                            }
                        }


                    },
                ]

            },

            {

                headerName: 'Dolares',

                children: [

                    {
                        field: 'PrecioLiquidacionD',
                        header: 'Precio U$',
                        headerEn: 'Price U$',
                        className: 'Xsmall',
                        Format: 'Currency',
                        hidden: userAuth.IdRol === 1,
                        editable: userAuth.IdRol === 1,

                        onChange: (data) => {
                            if (data.newValue || data.newValue === 0) {
                                let detalle = data.data
                                detalle.PrecioLiquidacionD = Number(data.newValue)
                                detalle.CostoD = RedondearNumero(((detalle.PrecioLiquidacionD * detalle.Cantidad) + detalle.ISVD), 2)

                                detalle.PrecioLiquidacionL = detalle.PrecioLiquidacionD * values.TasaCambio
                                detalle.CostoL = RedondearNumero(((detalle.PrecioLiquidacionL * detalle.Cantidad) + detalle.ISVL), 2)

                                detalle.IdMoneda = values.IdMoneda
                                let tempo = [...listadoDetalles]
                                let index = tempo.findIndex((t) => t.IdDetalle === detalle.IdDetalle)
                                tempo[index] = detalle

                                setListadoDetalles(tempo)
                                AsignarMontos(tempo, { ...values })
                            }
                        }
                    },
                    // {
                    //     field: 'SubTotalD',
                    //     header: 'SubTotalD',
                    //     headerEn: 'SubTotalD',
                    //     className: 'small',
                    //     Format: 'Currency',
                    //     // hidden: ocultar,
                    //     Sumary: 'sum',
                    //     Frozen: true,
                    //     alignFrozen: 'right',
                    // },

                    {
                        field: 'CostoD',
                        header: 'Costo $',
                        headerEn: 'Cost $',
                        className: 'Xsmall',
                        Format: 'Currency',
                        hidden: userAuth.IdRol === 1,
                        editable: userAuth.IdRol === 1,
                        Sumary: 'sum',
                        // editable: habilitar,

                        onChange: (data) => {

                            if (data.newValue || data.newValue === 0) {
                                let detalle = data.data
                                detalle.CostoD = data.newValue
                                detalle.CostoL = RedondearNumero(data.newValue * values.TasaCambio)
                                detalle.PrecioLiquidacionD = detalle.Cantidad > 0 ? detalle.CostoD / detalle.Cantidad : detalle.CostoD
                                detalle.PrecioLiquidacionL = detalle.Cantidad > 0 ? detalle.CostoL / detalle.Cantidad : detalle.CostoL
                                let tempo = [...listadoDetalles]
                                let index = tempo.findIndex((t) => t.IdDetalle === detalle.IdDetalle)
                                tempo[index] = detalle

                                setListadoDetalles(tempo)
                                AsignarMontos(tempo, { ...values })

                            }
                        }


                    },
                ]
            },

        ]
    }

    const verificarCampos = async () => {
        let errors = {}
        let isValid = true

        if (!values.Documento) {
            toastShow(toast, 'error', 'Completar los campos', 'Debe ingresar un numero de factura');
            errors.Documento = true
            errors.General = true
            isValid = false
        }

        if (!values.FechaEmision) {
            errors.FechaEmision = true
            errors.General = true
            isValid = false
        }
        if (!values.IdProveedor) {
            toastShow(toast, 'error', 'Completar los campos', 'Debe seleccionar el proveedor ');
            errors.IdProveedor = true
            errors.General = true
            isValid = false
        }

        if (!values.IdTerms) {
            toastShow(toast, 'error', 'Completar los campos', 'Debe seleccionar los terminos de la factura ');
            errors.IdTerms = true
            errors.General = true
            isValid = false
        }


        if (!values.IdMoneda) {
            errors.IdMoneda = true
            errors.General = true
            isValid = false
        }

        if (values.TasaCambio <= 0) {
            toastShow(toast, 'error', 'Completar los campos', 'Debe ingresar la tasa de cambio ');
            errors.TasaCambio = true
            errors.General = true
            isValid = false
        }

        let tempoCostoD = RedondearNumero(listadoDetalles.reduce((t, v) => t + v.CostoD, 0))
        let tempoCostoL = RedondearNumero(listadoDetalles.reduce((t, v) => t + v.CostoL, 0))

        // if (!values.CostoL || values.CostoL <= 0) {
        if (values.IsRegistroManual) {

            if (tempoCostoL !== RedondearNumero(values.CostoL)) {
                errors.CostoL = true
                errors.General = true
                isValid = false
            }

            if (tempoCostoD !== RedondearNumero(values.CostoD)) {
                errors.CostoD = true
                errors.General = true
                isValid = false
            }
        }

        if (!values.IdReferencia) {
            errors.IdReferencia = true
            errors.General = true
            isValid = false
        }



        // if(!values.OCE || ((values.OCE)?.trim())?.length === 0){
        //     errors.OCE = true
        //     errors.General = true
        //     isValid = false
        // }

        if (values.IdProveedor) {
            let infoProveedor = proveedores?.find((p) => p.IdCustomer === values?.IdProveedor)
            if (infoProveedor?.IdCountry === 95 && values.IdTerms !== 148) {
                if (!values.IdProveedorCAI || values.IdProveedorCAI <= 0) {
                    errors.IdProveedorCAI = true
                    errors.General = true
                    isValid = false
                    toastShow(toast, 'error', 'Debe agregar un cai al registro ');
                }
            }

            if (listadoDetalles.length > 0) {
                if (infoProveedor?.IdCountry === 95) {
                    let validoOCE = true

                    let detSinExento = listadoDetalles.find((l) => !l.IsExento || l.IsExento === 0)
                    let detExento = listadoDetalles.filter((le) => le.IsExento || le.IsExento === 1)
                    let detISV = listadoDetalles.find((l) => l.ISVD > 0 || l.ISVL > 0)
                    let existeOCE = !values.OCE || ((values.OCE)?.trim())?.length === 0
                    if (!detISV) {
                        if (detSinExento && existeOCE) {
                            validoOCE = false
                            toastShow(toast, 'error', 'Debe ingresar la OCE correpondiente a la factura ');
                        }
                    }

                    if (detISV) {
                        if (((values.OCE)?.trim())?.length > 0 && (detExento.length === listadoDetalles.length)) {
                            validoOCE = false
                            toastShow(toast, 'warn', 'No es necesario ingresar la OCE si todos los productos son exentos ');
                        }
                    }

                    if (!validoOCE) {
                        errors.OCE = true
                        errors.General = true
                        isValid = false
                    }

                }
            }

        }

        // const facturasExiste = await getVerificacionFactura(values)
        if (values.IsRegistroManual && values.IdTerms !== 148) {
            const facturasExiste = await getVerificacionFactura(values)
            if (facturasExiste.length > 0) {
                const continuar = await confirmacionFactura(facturasExiste)
                isValid = continuar
                if (!continuar) {
                    errors.Documento = continuar
                }
            }
        }


        setShowMessages({ ...errors, error: !isValid });
        if (Object.keys(errors).length === 0 && isValid) {
            return false;
        } else {
            console.log({ errors })
            return true
        }
    }

    const confirmacionFactura = async (ingresos) => {


        let message = <div style={{ width: '32vw' }} >
            <h5>Existen otros ingresos con la misma factura y el mismo proveedor </h5>
            {ingresos?.map((r) => {
                return <div className='pt-3'>
                    <span className='fw-bold'>  Proveedor: </span> {r.CustomerName} <br />
                    <span className='fw-bold'>Factura: </span> {r.Documento} <br />
                    <span className='fw-bold'> Fecha Factura:</span> {getDateString(new Date(r?.FechaDocumento))}
                    <span className='fw-bold mx-2'>Fecha Ingreso:</span> {getDateString(new Date(r?.IncomeDate))}
                    <br />
                </div>
            }
            )}
            <h6 className='fw-bold pt-4'> ¿Desea continuar con el mismo numero de factura ? </h6>
        </div>;
        let header = <div className="d-flex align-items-center">
            <i className="ri-message-3-line fs-2 me-2"></i>
            <h4 className="m-0">Ingresos</h4>
        </div>
        const confirmacion = await new Promise((resolve) => {
            confirmDialog({
                message: message,
                icon: 'pi pi-exclamation-triangle',
                accept: () => resolve(true),
                reject: () => resolve(false)

            })

        })

        return confirmacion

    }

    const verificarCamposDetalles = async () => {
        let ExisteError = []
        const verificar = await verificarCampos()

        if (values.IdProveedorCAI) {
            const tempoProveedoresCAI = await getCAIsProveedor(values?.IdProveedor)
            const filCAI = tempoProveedoresCAI.filter((c) => c.IdEstado !== 7)
            setProvedoresCAI(filCAI)
            setProvedoresCAIFiltrados(filCAI)

            let infoProveedor = tempoProveedoresCAI?.find((p) => p.IdProveedorCAI === values.IdProveedorCAI)
            if (!infoProveedor?.ProveedorInternacional) {


                let informacion = {
                    IdProveedorCAI: values.IdProveedorCAI,
                    Factura: values.Documento,
                    FechaFactura: values.FechaEmision
                }
                const verificacion = await verificarCAI(informacion)
                if (!verificacion.valido) {
                    toastShow(toast, 'error', '', verificacion.msj)
                    ExisteError.push(true)

                }

            }
        }


        // let ExisteError = false

        if (listadoDetalles.length === 0) {
            toastShow(toast, 'error', 'Debe agregar productos')
            return true
        }
        else {
            let errors = []
            let sinProducto = listadoDetalles.some((l) => l.IdProducto === null)
            let sinCantidad = listadoDetalles.some((l) => l.Cantidad <= 0)

            errors.push(
                { Name: 'Debe seleccionar los productos', error: sinProducto },
                { Name: 'La cantidad debe ser mayor a 0', error: sinCantidad }
            )

            let existeErrorD = errors.some((e) => e.error)

            if (verificar) {
                toastShow(toast, 'error', 'Debe ingresar la información correctamente.')
                ExisteError.push(true)
                // ExisteError = true
            }
            if (existeErrorD) {
                errors?.forEach((e) => {
                    if (e.error) {
                        toastShow(toast, 'error', e.Name)
                    }
                })
                ExisteError.push(true)
                // ExisteError = true
            }
            else {
                ExisteError.push(false)
                // ExisteError = false
            }
            errors = []





        }
        let e = ExisteError.some(e => e === true)
        return e

    }

    const GuardarInformacion = async (Cerrar = false) => {

        const VerificarInformacion = await verificarCamposDetalles()
        if (!VerificarInformacion) {
            const oceValido = VerificarOCE()
            if (!oceValido) {
                return
            }

            let CD = formatNumberDecimal(listadoDetalles.reduce((t, v) => t + v.CostoD, 0))
            let CL = formatNumberDecimal(listadoDetalles.reduce((t, v) => t + v.CostoL, 0))

            if (values.IsRegistroManual && (formatNumberDecimal(values.CostoD) !== CD) || (formatNumberDecimal(values.CostoL) !== CL)) {
                toastShow(toast, 'error', 'La Cantidad de la factura no es igual a los montos de los detalles')
            } else {
                let message = <div>¿Está seguro que desea guardar la información?</div>
                confirmDialog({
                    message: message,
                    header: 'Confirmación',
                    icon: 'pi pi-exclamation-triangle',
                    accept: async () => {
                        setLoading(true)
                        let valuesEnc = {
                            ...values,
                            FechaEmision: getDateTimeStringSQL(new Date(values.FechaEmision)),
                            FechaIngreso: getDateTimeStringSQL(new Date(values.FechaIngreso)),
                            // MontoL: values.MontoL,
                            // MontoD: MD,
                            IdUserIngreso: userAuth.idUser,
                            TasaCambio: values.TasaCambio,
                            IdUserEdit: userAuth.idUser,
                            IdUserIngresoCompras: userAuth.idUser,
                            IdUserEditCompras: userAuth.idUser,
                            Memo: values.Memo === null ? values.Comentario : values.Memo,
                            FechaRecibidoCompras: values.FechaRecibidoCompras === null ? getDateTimeStringSQL(new Date()) : values.FechaRecibidoCompras,
                            FechaRecibidoFinanzas: values.FechaRecibidoFinanzas !== null ? values.FechaRecibidoFinanzas : null,
                            OCE: ((values.OCE)?.trim())?.length === 0 ? null : values.OCE
                        }

                        let detalles = listadoDetalles.map((l) => {
                            return {
                                ...l,
                                IdUserEdit: userAuth.idUser
                            }
                        })

                        const datosEnviar = {
                            Encabezado: valuesEnc,
                            Detalles: detalles
                        }
                        if (values.IsRegistroManual) {
                            const result = await postRegistroCuentasPorPagar(datosEnviar)

                            if (result?.length > 0) {
                                if (result[0]?.Error === 0) {
                                    let tempoValues = { ...values }
                                    if (!Cerrar) {
                                        tempoValues.Id = result[0]?.IdFactura
                                        setValues(tempoValues)
                                        ObtenerDetalles(tempoValues.Id)
                                    }
                                    toastShow(toast, 'success', 'Registro Ingresado Correctamente')
                                    setTimeout(() => {
                                        if (Cerrar) {
                                            CerrarInformacion()
                                        }
                                    }, 1000);

                                }
                                else {
                                    toastShow(toast, 'error', 'Ocurrio un error al ingresar el registro')
                                }
                            } else {
                                toastShow(toast, 'error', 'Ocurrio un error al ingresar el registro')
                            }

                        } else {
                            if (valuesEnc.Id > 0) {
                                const resultConsolidado = await postEncabezadoConsolidadoInv(datosEnviar)
                                if (resultConsolidado?.length > 0) {
                                    if (resultConsolidado[0]?.Error === 0) {
                                        let tempoValues = { ...values }
                                        if (!Cerrar) {
                                            tempoValues.Id = resultConsolidado[0]?.IdFactura
                                            setValues(tempoValues)
                                            obtenerDetallesIngreso(tempoValues)
                                        }
                                        toastShow(toast, 'success', 'Registro Ingresado Correctamente')
                                        setTimeout(() => {
                                            if (Cerrar) {
                                                CerrarInformacion()
                                            }
                                        }, 1000);

                                    }
                                    else {
                                        toastShow(toast, 'error', 'Ocurrio un error al ingresar el registro')
                                    }
                                } else {
                                    toastShow(toast, 'error', 'Ocurrio un error al ingresar el registro')
                                }
                            } else {
                                const r = await postIUEncabezadoConsolidadoInv(datosEnviar)
                                // console.log(r)
                                if (r?.length > 0) {
                                    if (r[0]?.ERROR === 0) {
                                        let tempoValues = { ...values }

                                        if (!Cerrar) {
                                            tempoValues.Id = r[0]?.IdFactura
                                            tempoValues.IdIngresoReferencia = r[0]?.IdFactura
                                            setValues(tempoValues)
                                            obtenerDetallesIngreso(tempoValues)
                                        }
                                        toastShow(toast, 'success', 'Registro Ingresado Correctamente')
                                        setTimeout(() => {
                                            if (Cerrar) {
                                                CerrarInformacion()
                                            }
                                        }, 1000);
                                    } else {
                                        toastShow(toast, 'error', r[0]?.MSJ)
                                    }
                                } else {
                                    toastShow(toast, 'error', 'Ocurrio un error al ingresar el resgistro')
                                }
                            }

                        }

                        setLoading(false)
                        setHabilitar(!habilitar)
                    },
                    reject: () => { }
                })
            }

        }
    }

    const Calcular = (temValues = values) => {

        let detalles = [...listadoDetalles]
        detalles.forEach((detail) => {
            detail.CostoD = RedondearNumero((detail.MontoD) - (!detail.AplicaISV ? detail.ISVD : 0))
            detail.CostoL = RedondearNumero((detail.MontoL) - (!detail.AplicaISV ? detail.ISVL : 0))

            detail.PrecioLiquidacionL = detail.CostoL / detail.Cantidad
            detail.PrecioLiquidacionD = detail.CostoD / detail.Cantidad

            detail.SubTotalD = detail.CostoD
            detail.SubTotalL = detail.CostoL



        })



        setListadoDetalles(detalles)
        AsignarMontos(detalles, temValues)


    }

    const CambiarProveedor = (e) => {
        if (e) {
            let infoProveedor = proveedores?.find((p) => p.IdCustomer === e)
            let tempoValues = { ...values }
            tempoValues.IdProveedor = e
            tempoValues.IdProveedorCAI = null
            tempoValues.NombreSucursal = ''
            tempoValues.Documento = ''
            tempoValues.IdCuenta = infoProveedor?.IdCountry === 95 ? 15 : 16


            setValues(tempoValues)
        }
    }

    const CambiarMoneda = (e) => {
        if (e) {
            handleChange(e, 'IdMoneda')
            // console.log(ocultar,);
            setOcultar(!ocultar)
        }
    }

    const CambiarProveedorCAI = (e, op) => {
        let tempoValues = { ...values }
        tempoValues.IdProveedorCAI = e?.data?.IdProveedorCAI
        tempoValues.NombreSucursal = e?.data.NombreSucursal
        if (tempoValues.Documento?.length <= 0) {
            tempoValues.Documento = e?.data.Prefijo
        }
        setValues(tempoValues)
        op.current.toggle(e)
        // e?.api.stopEditing();
    }

    const CambiarTasaCambio = (value) => {
        let tempoValues = { ...values }
        if (value > 0) {
            tempoValues.TasaCambio = value

            let tempoDetalles = [...listadoDetalles]
            tempoDetalles.forEach((d) => {
                d.TasaCambio = value
                if (tempoValues.IdMoneda === 1) {
                    d.MontoL = RedondearNumero(d.MontoD * value)
                    d.PrecioL = d.MontoL / d.Cantidad
                    d.ISVL = RedondearNumero(d.ISVD * value)
                }
                else {
                    d.MontoD = RedondearNumero(d.MontoL / value)
                    d.PrecioD = d.MontoD / d.Cantidad
                    d.ISVD = RedondearNumero(d.ISVL / value)
                }
            });
            setListadoDetalles(tempoDetalles)
            setValues(tempoValues)
            Calcular(tempoValues)
            // AsignarMontos(tempoDetalles, tempoValues)


        }

    }

    const CambiarEstadosCheck = (IdEstado) => {
        let tempoValues = { ...values }
        tempoValues.IdEstadoFinanzas = IdEstado


        switch (IdEstado) {
            case 3714:
                tempoValues.FechaRevisadoBodega = getDateTimeStringSQL24(new Date())
                tempoValues.FechaRecibidoCompras = null
                break;
            case 3580:
                tempoValues.FechaRevisadoBodega = null
                tempoValues.FechaRecibidoCompras = null
                break;
            case 3713:
                tempoValues.FechaRecibidoCompras = getDateTimeStringSQL24(new Date())
                break;
            default:
                break;
        }
        console.log(tempoValues, IdEstado)

        setValues(tempoValues)
    }




    const hideDividir = () => {
        setDialogDividir(false)
        setSelected([])
        Calcular()
    }


    const AsignarInformacionPO = (e, POS, op, manual = false) => {
        if (e) {
            let dataPO
            if (!manual) {
                dataPO = e?.data
            } else {
                dataPO = e
            }


            let tempoValues = { ...values }
            tempoValues.IdPO = dataPO?.IdPurchaseOrder
            tempoValues.PurchaseOrder = dataPO?.PurchaseOrder
            tempoValues.IdProveedor = dataPO?.IdVendor
            tempoValues.IdMoneda = dataPO?.IdCurrency
            tempoValues.IdTerms = dataPO?.IdPaymentTerms
            tempoValues.IdCuenta = dataPO?.IdCountry === 95 ? 15 : 16

            let terminoValor = terminos?.find((t) => t.IdTerm === dataPO?.IdPaymentTerms)

            if (terminoValor) {
                const fechaV = agregarDias(tempoValues?.FechaEmision, terminoValor?.TermValue)
                tempoValues.FechaVencimiento = fechaV

            }
            if (dataPO?.IdCurrency > 0) {
                setOcultar([1, 3]?.includes(dataPO?.IdCurrency) ?? false)
            }


            setValues(tempoValues)

            if (POS?.length > 0) {
                NuevaFila(POS, tempoValues)
                setHabilitarPO(true)

            }
        }
        if (!manual) {
            op?.current?.toggle(e)
        }
    }

    const ValidarFactura = async (numeroFactura) => {
        let tempoValues = { ...values }
        // if (numeroFactura.length === 19) {
        if (values.IdProveedor > 0) {
            // let caisProveedor = proveedoresCAI.filter((p) => p.IdProveedor === values.IdProveedor)
            // let n = (numeroFactura).slice(-8)
            // let prefijo = (numeroFactura).substr(-20, 10)

            let informacionVerificar = {
                IdProveedor: tempoValues.IdProveedor,
                IdProveedorCAI: tempoValues.IdProveedorCAI,
                Factura: tempoValues.Documento,
                FechaFactura: tempoValues.FechaEmision
            }
            const verificaionCAI = await ValidarFacturaProveedor(informacionVerificar)
            if (verificaionCAI) {
                if (verificaionCAI?.Valido) {
                    tempoValues.IdProveedorCAI = verificaionCAI?.Valores?.IdProveedorCAI
                    tempoValues.NombreSucursal = verificaionCAI?.Valores?.NombreSucursal
                } else {
                    toastShow(toast, 'warn', verificaionCAI.Mensaje)
                }
            }


            setValues(tempoValues)
        }
        // }{
        //     tempoValues.Documento =numeroFactura
        // }

    }

    const ObtenerFechaVencimiento = async (fechaD, IdTerm, Componente) => {
        let tempoValues = { ...values }
        tempoValues.FechaEmision = new Date(fechaD)

        if (IdTerm > 0) {
            tempoValues.IdTerms = IdTerm
            let terminoValor = terminos.find((t) => t.IdTerm === IdTerm)

            if (terminoValor) {
                tempoValues.FechaEmision = new Date(fechaD)
                const fechaV = agregarDias(fechaD, terminoValor?.TermValue)
                tempoValues.FechaVencimiento = fechaV

            }
        }

        if (Componente === 1) {

            const tempoTasa = await obtenerTasaCambioFinanzas(fechaD)
            if (tempoTasa > 0) {
                if (tempoTasa !== tempoValues.TasaCambio) {

                    let message = <div>¿Desea cambiar la tasa de cambio en relación a la fecha seleccionada?</div>
                    confirmDialog({
                        message: message,
                        header: 'Confirmación',
                        icon: 'ri-message-3-line',
                        accept: async () => {
                            tempoValues.TasaCambio = tempoTasa

                            let tempoDetalles = [...listadoDetalles]
                            tempoDetalles.forEach((d) => {
                                d.TasaCambio = tempoTasa
                                if (tempoValues.IdMoneda === 1) {
                                    d.MontoL = RedondearNumero(d.MontoD * tempoTasa)
                                    d.PrecioL = d.MontoL / d.Cantidad
                                }
                                else {
                                    d.MontoD = RedondearNumero(d.MontoL / tempoTasa)
                                    d.PrecioD = d.MontoD / d.Cantidad
                                }
                            });
                            setListadoDetalles(tempoDetalles)
                            // setValues(tempoValues)
                            Calcular(tempoValues)
                        },
                        reject: () => {
                            setValues(tempoValues)
                        }
                    })
                } else {

                }
            }
            setValues(tempoValues)
        } else {
            setValues(tempoValues)
        }
    }

    const EliminarIngreso = async () => {
        let message = 'Esta seguro que desea eliminar el ingreso'
        confirmDialog({
            message: message,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
                let valuesEnc = {
                    ...values,
                    IdEstado: 2063,
                    IdUserEdit: userAuth.idUser,
                    IdUserEditCompras: userAuth.idUser
                }

                let detalles = listadoDetalles.map((l) => {
                    return {
                        ...l,
                        IdEstado: 2063,
                        IdUserEdit: userAuth.idUser
                    }
                });

                const datosEnviar = {
                    Encabezado: valuesEnc,
                    Detalles: detalles
                }

                const result = await postEliminarIngresoDeCuentasPorPagar(datosEnviar)
                if (result) {
                    toastShow(toast, 'success', 'Ingreso Eliminado Correctamente')
                    setTimeout(() => {
                        hideDialog()
                    }, 1000);
                }
                else {
                    toastShow(toast, 'error', 'Ocurrio un error al eliminar el ingreso')
                }
            },
            reject: () => { }
        })
    }

    const CerraModal = () => {
        if (habilitar) {

            if (listadoDetalles?.length > 0) {
                let message = <div>¿Desea guardar antes de cerrar?</div>
                confirmDialog({
                    message: message,
                    header: 'Confirmación',
                    icon: 'pi pi-exclamation-triangle',
                    accept: async () => GuardarInformacion(),
                    reject: async () => hideDialog()
                });
            } else {
                hideDialog()
            }

        } else {

            hideDialog()
        }
    }

    const Pagado = () => {
        let tempoPagadoD = Number((values?.MontoD)?.toFixed(2)) - Number((values?.ValorPagadoD)?.toFixed(2))
        let tempoPagadoL = Number((values?.MontoL)?.toFixed(2)) - Number((values?.ValorPagadoL)?.toFixed(2))
        if ((tempoPagadoD === 0 || tempoPagadoL === 0) || values.Pagado === 1) {
            return <Tag style={{ width: 100, backgroundColor: '#00bf39', fontSize: '14px' }} value='PAGADO' />
        } else {
            return null
        }
    }

    const NuevoRegistro = () => {
        if (habilitar && values.IdPO > 0) {
            let message = <div>¿Desea guardar la informacion antes de crear un nuevo registro?</div>
            confirmDialog({
                message: message,
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                accept: async () => {
                    GuardarInformacion(true)
                },
                reject: async () => {
                    CerrarInformacion()

                }
            });
        } else {
            CerrarInformacion()

        }



    }

    const ObtenerTasa = async () => {

        let tempoValues = { ...values }

        let mesActual = new Date().getMonth() + 1
        let anioActual = new Date().getFullYear()

        const tempoMes = await getCalendarioFinanzasMensualProduccion()

        if (tempoMes?.length > 0) {
            let cal = tempoMes.find((m) => m.NoMes === mesActual && m.Anio === anioActual)
            let calMesActivo = tempoMes.find((m) => m.IdEstado === 1)
            tempoValues.TasaCambio = tempoValues.IsRegistroManual ? (cal?.TasaCambio || calMesActivo?.TasaCambio) : calMesActivo?.TasaCambio
        }

        return tempoValues.TasaCambio
    }

    const CerrarInformacion = async () => {
        setLoading(true)
        resetForm({})

        setListadoDetalles([])
        setSelected([])
        setHabilitarPO(!habilitasPO)
        setShowMessages({ error: false })
        setHabilitar(!habilitar)

        // setValues({...valoresIniciales})

        InformacionInicial({ ...valoresIniciales })

        setLoading(false)


    }

    const BuscarPO = async (value) => {
        let tempoValues = { ...values }
        tempoValues.PurchaseOrder = value
        setValues(tempoValues)
        if (value?.length === 10) {
            const result = await getPurchaseOrder(value)
            if (result.length > 0) {
                let IdPO = result[0]?.IdPurchaseOrder
                if (IdPO > 0) {
                    const tempoDetalles = await getBalancePurchaseDetails(IdPO)
                    if (tempoDetalles?.length > 0) {
                        AsignarInformacionPO(result[0], tempoDetalles, null, true)
                    } else {
                        toastShow(toast, 'error', ' No existen productos con balance de la orden seleccionada')
                    }
                }
            }
        }
    }

    const VerificarOCE = () => {
        let errors = {}
        let isValid = true
        let validoOCE = true
        let detSinExento = listadoDetalles.find((l) => !l.IsExento || l.IsExento === 0)
        let detExento = listadoDetalles.filter((le) => le.IsExento || le.IsExento === 1)
        let detISV = listadoDetalles.find((l) => l.ISVD > 0 || l.ISVL > 0)
        const oce = values.OCE?.trim()
        let existeOCE = !values.OCE || values.OCE.trim().length === 0
        if (values?.IdCountry === 95) {
            if (!detISV) {
                if (detSinExento && existeOCE) {
                    validoOCE = false
                    toastShow(toast, 'error', 'Debe ingresar la OCE correpondiente a la factura '
                    )
                }
            }

            if (detISV) {
                if (oce && oce.length > 0 && detExento.length === listadoDetalles.length
                ) {
                    validoOCE = false
                    toastShow(toast, 'warn', 'No es necesario ingresar la OCE si todos los productos son exentos '
                    )
                }
            }

            if (oce && oce.length > 0) {
                if (!/^OC\d{4}\d{6}$/.test(oce)) {
                    validoOCE = false
                    toastShow(toast, 'error', 'El OCE debe tener formato OCYYYY000000 (12 caracteres)'
                    )
                }
            }

            if (!validoOCE) {
                errors.OCE = true
                errors.General = true
                isValid = false
            }
        }

        return isValid
    }

    const RemoverCAI = () => {
        let tempoValues = { ...values }
        tempoValues.IdProveedorCAI = null
        tempoValues.NombreSucursal = ''
        if (tempoValues.Documento?.length <= 0) {
            tempoValues.Documento = ''
        }
        setValues(tempoValues)
    }



    useEffect(() => {
        if (listadoDetalles?.length > 0 && dialogDividir) {
            hideDividir()
        }
    }, [listadoDetalles])


    useEffect(() => {
        if (values.Documento) {
            if (values?.Documento?.length === 19) {
                ValidarFactura(values.Documento)
            }
        }
    }, [values.Documento])

    useEffect(() => {
        if (dialogCuentas) {
            ObtenerInformacionDropdown()
            obtenerInformacion()
        } else {
            resetForm({})
            setShowMessages({ error: false })
            setListadoDetalles([])
            setSelected([])
            setOcultar(false)
            setHabilitarPO(false)
            setHabilitar(true)
            setEliminarIngreso(true)


        }
    }, [dialogCuentas])

    // const VerificarFactura = async () => {
    //     const facturasExiste = await getVerificacionFactura(values)
    //     if (facturasExiste.length > 0) {
    //       const continuar = await confirmacionFactura(facturasExiste)
    //     }
    // }

    return (
        <Dialog visible={dialogCuentas} onHide={() => CerraModal()} maximizable maximized closeOnEscape={false}
            header={<div className='d-flex gap'><h3>{values.NoIngreso}</h3>
                {Pagado()}
            </div>}>
            <Toast ref={toast} />
            <div className='columns8CP'>
                <Card
                    titulo='PO'
                    contenido={<div className='d-flex flex-row' style={{ width: '100%' }}>
                        <InputText
                            value={values.PurchaseOrder}
                            style={{ width: 115, borderEndEndRadius: 0 }}
                            onChange={(e) => BuscarPO(e?.target?.value)} disabled={habilitasPO}
                            className={classNames({ 'p-invalid': showMessages?.PurchaseOrder })}
                        />
                        <AllPurchaseOrderOverlayPanel
                            onChange={AsignarInformacionPO}
                            habilitasPO={habilitasPO}
                        />
                    </div>}

                />
                {/* OC2024246581 */}
                <Card
                    titulo='OCE'
                    contenido={<div>
                        <InputText
                            value={values.OCE}
                            onChange={(e) => handleInputChange(e, 'OCE')}
                            className={classNames({ 'p-invalid': showMessages?.OCE })}
                            style={{ width: '100%' }} disabled={!habilitar}
                        />
                        {/* <InputMask
                            id="basic"
                            value={values.OCE}
                            onChange={(e) => handleInputChange(e, 'OCE')}
                            mask="a*9999999999"
                            placeholder="OC0000000000"
                            className={classNames({ 'p-invalid': showMessages?.OCE })}
                            style={{ width: '100%' }} disabled={!habilitar}
                        /> */}
                    </div>}
                />

                <Card
                    titulo={getLabel(CuentasPorPagarLang, 'Proveedor', config?.language)}
                    contenido={<div>
                        <Dropdown
                            value={values.IdProveedor}
                            onChange={(e) => CambiarProveedor(e.value)}
                            options={proveedores}
                            optionValue='IdCustomer' optionLabel='CustomerName'
                            filter filterBy='CustomerName'
                            style={{ width: '100%' }}
                            disabled={(!habilitar && !values.IsRegistroManual) || userAuth.IdRol !== 2}
                            className={classNames({ 'p-invalid': showMessages?.IdProveedor })}

                        />
                    </div>}
                />

                <Card
                    titulo={getLabel(CuentasPorPagarLang, 'ProveedorCAI', config?.language)}
                    contenido={<div className='d-flex flex-row'>
                        <InputText
                            value={values.NombreSucursal}
                            style={{ width: '100%', borderEndEndRadius: 0 }} disabled
                            className={classNames({ 'p-invalid': showMessages?.IdProveedorCAI })}
                        />

                        <OverlaySeleccionProveedoresCAI
                            IdProveedor={values.IdProveedor}
                            values={values}
                            onChange={CambiarProveedorCAI}
                            close={() => { }}
                            habilitar={habilitar}
                            RemoverCAI={RemoverCAI}
                        />
                    </div>}
                />
                <Card
                    titulo={getLabel(CuentasPorPagarLang, 'Factura', config?.language)}
                    contenido={<div>
                        <InputText
                            value={values.Documento}
                            // onChange={(e) => ValidarFactura(e.target.value)}
                            onChange={(e) => handleInputChange(e, 'Documento')}
                            style={{ width: '100%' }} disabled={!habilitar}
                            className={classNames({ 'p-invalid': showMessages?.Documento })}

                        />
                    </div>}
                />



                <Card
                    titulo={getLabel(CuentasPorPagarLang, 'FechaFactura', config?.language)}
                    contenido={<div>
                        <Calendar
                            value={values.FechaEmision} dateFormat="dd/mm/yy"
                            // onChange={(e) => handleInputChange(e, 'FechaEmision')}
                            onChange={(e) => ObtenerFechaVencimiento(e.value, values.IdTerms, 1)}
                            style={{ width: '100%' }} showIcon disabled={!habilitar} showButtonBar
                            className={classNames({ 'p-invalid': showMessages?.FechaEmision })}

                        />
                    </div>}
                />

                <Card
                    titulo={getLabel(CuentasPorPagarLang, 'Terminos', config?.language)}
                    contenido={<div>
                        <Dropdown
                            value={values.IdTerms}
                            // onChange={(e) => handleInputChange(e, 'IdTerms')}
                            onChange={(e) => ObtenerFechaVencimiento(values.FechaEmision, e?.target.value, 2)}
                            options={terminos}
                            optionValue='IdTerm' optionLabel='TermName'
                            filter filterBy=''
                            style={{ width: '100%' }} disabled={!habilitar}
                            className={classNames({ 'p-invalid': showMessages?.IdTerms })}

                        />
                    </div>}
                />
                <Card
                    titulo={getLabel(CuentasPorPagarLang, 'FechaIngreso', config?.language)}
                    contenido={<div>
                        <Calendar
                            value={values.FechaIngreso} dateFormat="dd/mm/yy"
                            onChange={(e) => handleInputChange(e, 'FechaIngreso')}
                            style={{ width: '100%' }} showIcon disabled={!values.IsRegistroManual ?? !habilitar} showButtonBar
                            className={classNames({ 'p-invalid': showMessages?.FechaIngreso })}

                        />
                    </div>}
                />


            </div>
            <div className='columnsCXPEENC'>
                <Card
                    titulo={getLabel(CuentasPorPagarLang, 'Moneda', config?.language)}
                    contenido={<div>
                        <Dropdown
                            value={values.IdMoneda}
                            onChange={(e) => CambiarMoneda(e.value)}
                            options={monedas}
                            optionValue='IdCurrency' optionLabel='Currency'
                            filter filterBy=''
                            style={{ width: '100%' }} disabled={values.IsRegistroManual ? (!habilitar || values.IdPO > 0) : true}
                            className={classNames({ 'p-invalid': showMessages?.IdMoneda })}

                        />
                    </div>}
                />

                <Card
                    titulo={getLabel(CuentasPorPagarLang, 'TasaCambio', config?.language)}
                    contenido={<div  >
                        {/* <NumericFormat
                            style={{ height: 40, width: '100%' }}
                            value={values.TasaCambio}
                            onValueChange={(values, sourceInfo) => {

                                CambiarTasaCambio(values.floatValue);
                                // CambiarTasaCambio(values.floatValue)
                                // handleChange(values.floatValue, 'TasaCambio')
                            }}
                            className={classNames({ 'p-invalid': showMessages?.TasaCambio }, "InputNumberStyle")}
                            allowLeadingZeros
                            thousandSeparator="," disabled={values.IsRegistroManual ? !habilitar : true}
                        /> */}

                        <InputNumber
                            value={values.TasaCambio}
                            onChange={(e) => CambiarTasaCambio(e.value)}
                            disabled={values.IsRegistroManual ? !habilitar : true}
                            className={classNames({ 'p-invalid': showMessages?.TasaCambio }, 'widthTasaCambio')}
                            minFractionDigits={2} maxFractionDigits={5}
                            style={{ height: 40, width: '100%' }}

                        />

                    </div>}
                />



                <Card
                    titulo={getLabel(CuentasPorPagarLang, 'MontoL', config?.language)}
                    contenido={<div>
                        <NumericFormat
                            style={{ height: 40, width: '100%' }}
                            value={values.MontoL}
                            onValueChange={(values, sourceInfo) => {
                                handleChange(values.floatValue, 'MontoL')
                            }}
                            className={classNames({ 'p-invalid': showMessages?.MontoL }, "InputNumberStyle")}
                            allowLeadingZeros
                            thousandSeparator="," disabled={values.IsRegistroManual ? !habilitar : true}
                        />
                    </div>}
                />

                <Card
                    titulo={getLabel(CuentasPorPagarLang, 'MontoD', config?.language)}
                    contenido={<div>
                        <NumericFormat
                            style={{ height: 40, width: '100%' }}
                            value={values.MontoD}
                            onValueChange={(values, sourceInfo) => {
                                handleChange(values.floatValue, 'MontoD')
                            }}
                            className={classNames({ 'p-invalid': showMessages?.MontoD }, "InputNumberStyle")}
                            allowLeadingZeros
                            thousandSeparator="," disabled={values.IsRegistroManual ? !habilitar : true}
                        />
                    </div>}
                />
                <Card
                    titulo={getLabel(CuentasPorPagarLang, 'TipoFactura', config?.language)}
                    contenido={<div>
                        <Dropdown
                            value={values.IdReferencia}
                            onChange={(e) => handleInputChange(e, 'IdReferencia')}
                            optionLabel='NombreReferencia'
                            optionValue='IdReferencia'
                            options={referencias}
                            style={{ width: '100%' }}
                            className={classNames({ 'p-invalid': showMessages?.IdReferencia })}
                            disabled={values.IsRegistroManual ? !habilitar : true}
                        // disabled={!habilitar}

                        />
                    </div>}
                />


                <Card
                    titulo={getLabel(CuentasPorPagarLang, 'Comentario', config?.language)}
                    contenido={<div>
                        <InputText
                            value={values.Comentario}
                            onChange={(e) => handleInputChange(e, 'Comentario')}
                            style={{ width: '100%' }} disabled={!habilitar}
                            className={classNames({ 'p-invalid': showMessages?.Comentario })}
                        />
                    </div>}

                />

                <Card
                    titulo={getLabel(CuentasPorPagarLang, 'FechaVencimiento', config?.language)}
                    contenido={<div>
                        <Calendar
                            value={values.FechaVencimiento} dateFormat="dd/mm/yy"
                            onChange={(e) => handleInputChange(e, 'FechaVencimiento')}
                            style={{ width: '100%' }} showIcon disabled
                            className={classNames({ 'p-invalid': showMessages?.FechaVencimiento })}

                        />
                    </div>}
                />
            </div>
            {showMessages.General && <div className="p-error">{getLabel(CuentasPorPagarLang, 'MensajeError', config?.language)}</div>}
            {showMessages.Fechas && <div className="p-error">{getLabel(CuentasPorPagarLang, 'MensajeError', config?.language)}</div>}
            <div>
                <Card
                    titulo={getLabel(CuentasPorPagarLang, 'Herramientas', config?.language)}
                    contenido={<div className='d-flex flex-row' style={{ justifyContent: 'space-between' }} >
                        <div className='flexBox' style={{ alignItems: 'center' }}>
                            {/* {userAuth.IdRol === 1 ? <Button icon='pi pi-plus' onClick={() => NuevaFilaVacia()} style={{ backgroundColor: "slategray", width: 40, height: 35 }}
                                disabled={!habilitar || values.IdEstadoFinanzas === 3581} tooltip={getLabel(CuentasPorPagarLang, 'BtnNuevaFila', config?.language)} /> : null} */}
                            <AllPurchaseOrderDetailsOverlayPanel
                                values={values}
                                NuevaFila={NuevaFila}
                                close={() => { }}
                                habilitar={values.IsRegistroManual ? (values.IdPO > 0 && habilitar) : false}
                            />

                            <Button icon='pi pi-times' onClick={() => RemoverFilas()} style={{ backgroundColor: "#f12456", width: 40, height: 35 }}
                                disabled={values.IsRegistroManual ? (!habilitar || values.IdEstadoFinanzas === 3581) : true} tooltip={getLabel(CuentasPorPagarLang, 'BtnRemoveroFila', config?.language)} />
                            <Button icon="pi pi-save" onClick={() => GuardarInformacion()} style={{ width: 40, height: 35 }} loading={loading}
                                disabled={!habilitar} tooltip={getLabel(CuentasPorPagarLang, 'BtnGuardar', config?.language)} />
                            {/* <Button icon="pi pi-pencil" onClick={() => setHabilitar(!habilitar)} loading={loading} style={{ width: 40, height: 35, backgroundColor: "slategray" }}
                                disabled={habilitar || !values.IsRegistroManual || values.IdEstadoFinanzas === 3581} tooltip={getLabel(CuentasPorPagarLang, 'BtnEditar', config?.language)} /> */}
                            <Button icon="pi pi-pencil" onClick={() => setHabilitar(!habilitar)} loading={loading} style={{ width: 40, height: 35, backgroundColor: "slategray" }}
                                disabled={accesoHabilitar ? (habilitar || values.IdEstadoFinanzas === 3581 || values.ValorPagadoD > 0) : true}

                                tooltip={getLabel(CuentasPorPagarLang, 'BtnEditar', config?.language)} />
                            <Button icon="pi pi-refresh" onClick={() => obtenerInformacion()} style={{ width: 40, height: 35 }} loading={loading}
                                disabled={values.Id > 0 ? false : true} tooltip={getLabel(CuentasPorPagarLang, 'BtnRecargar', config?.language)} />
                            <Button icon="ri-folder-user-line" onClick={() => setDialogCAI(true)} disabled={values.IdProveedor > 0 ? false : true}
                                style={{ width: 40, height: 35 }} tooltip='CAIs' />

                            {/* <Button className='mx-2' icon='pi pi-print' onClick={() => openReporte()} disabled={(values.Id > 0 && values.IdReferencia === 9) ? false : true} style={{ width: 40, height: 35 }} /> */}
                            {values.IsRegistroManual && values.Id > 0 ?
                                <Button onClick={() => EliminarIngreso()} icon='ri ri-delete-bin-line' style={{ backgroundColor: "#f12456", height: 35 }}
                                    // disabled={habilitar ? (values.Id < 0 || values.IdEstadoFinanzas === 3581 || values.ValorPagadoD > 0) : true} 
                                    disabled={!eliminarIngreso}
                                    tooltip={getLabel(CuentasPorPagarLang, 'BtnEliminarRegistro', config?.language)} loading={loading} />
                                : null}
                            {values.IsRegistroManual ?
                                <Button icon='ri-file-add-line' onClick={() => NuevoRegistro()} label={getLabel(CuentasPorPagarLang, 'NuevoRegistro', config?.language)}
                                    style={{ height: 35 }} disabled={!values.IdPO} />
                                : null}


                            <div style={{ width: '12vw' }} className='mx-2'>
                                <span className="p-float-label">
                                    <Dropdown
                                        value={values.IdEstadoFinanzas}
                                        onChange={(e) => handleInputChange(e, 'IdEstadoFinanzas')}
                                        options={estados}
                                        optionLabel='StatusName'
                                        optionValue='IdStatus'
                                        style={{ width: '100%' }}
                                        disabled={userAuth.IdRol !== 1}

                                    />
                                    <label htmlFor="Estado">{getLabel(CuentasPorPagarLang, 'EstadoFinanzas', config?.language)}</label>
                                </span>
                            </div>
                            {userAuth.idUser === 290 ? <Button onClick={() => VerificarOCE()} icon='ri ri-survey-line' /> : null}

                            {
                                !values.IsRegistroManual && ![5, 7, 10].includes(values.IdReferencia) && [1, 1036, 1056].includes(userAuth.IdRol) ?
                                    <span className='d-flex gap'>
                                        <Checkbox checked={[3714, 3713, 3581, 3607].includes(values.IdEstadoFinanzas)} onChange={(e) =>
                                            CambiarEstadosCheck((e.checked ? 3714 : 3580))}
                                            disabled={habilitar ? [3713, 3607, 3581].includes(values.IdEstadoFinanzas) : true} />
                                        <label>Revisión Bodega</label>
                                    </span>
                                    : null
                            }

                            {
                                !values.IsRegistroManual && [1, 8].includes(userAuth.IdRol) ?
                                    <span className='d-flex gap'>
                                        <Checkbox checked={[3713, 3581, 3607].includes(values.IdEstadoFinanzas)} onChange={(e) =>
                                            CambiarEstadosCheck((e.checked ? 3713 : (![5, 7].includes(values.IdReferencia) ? 3714 : 3580)))}
                                            disabled={!habilitar ? true : ([5, 7, 10].includes(values.IdReferencia) ? [3607, 3581].includes(values.IdEstadoFinanzas) : [3580, 3607, 3581].includes(values.IdEstadoFinanzas))} />
                                        <label>Recibido Compras</label>
                                    </span> : null
                            }
                            {/* {values.IsRegistroManual && userAuth.idUser === 290 ?
                                <Button icon='ri-checkbox-circle-line' onClick={() => VerificarFactura()}
                                    style={{ height: 35 }} />
                                : null} */}
                        </div>
                        {userAuth.IdRol === 1 ?
                            <div className='d-flex flex-row' style={{ alignItems: 'center' }}>
                                <span className="p-float-label">
                                    <NumericFormat
                                        style={{ height: 30, width: '95%' }}
                                        value={values.CostoL}
                                        onValueChange={(values, sourceInfo) => {
                                            handleChange(values.floatValue, 'CostoL')
                                        }}
                                        className='InputNumberStyle p-filled'
                                        allowLeadingZeros
                                        thousandSeparator=','
                                        disabled={!habilitar}

                                    />

                                    <label htmlFor="CostoL">{getLabel(CuentasPorPagarLang, 'CostoL', config?.language)}</label>
                                </span>
                                <span className="p-float-label">
                                    <NumericFormat
                                        style={{ height: 30, width: '95%' }}
                                        value={values.CostoD}
                                        onValueChange={(values, sourceInfo) => {
                                            handleChange(values.floatValue, 'CostoD')
                                        }}
                                        className='InputNumberStyle p-filled'
                                        allowLeadingZeros
                                        thousandSeparator=','
                                        disabled={!habilitar}

                                    />

                                    <label htmlFor="CostoD">{getLabel(CuentasPorPagarLang, 'CostoD', config?.language)}</label>
                                </span>
                            </div>
                            : null

                        }

                    </div>}

                />

            </div>
            <Loader loading={loading} querySelector={'#ModalDetallesCXP'} />
            <div className='pt-2' style={{ height: '60vh' }} id='ModalDetallesCXP'>
                <AgGrid table={table} />

            </div>
            {values.Id > 0 ?
                <div className='d-flex flex-row' style={{ justifyContent: 'flex-end' }} >

                    <div className='d-flex flex-column' style={{ alignItems: 'flex-end' }}>
                        <span style={{ fontSize: 11 }}>{getLabel(CuentasPorPagarLang, 'FechaRecibidoCompras', config?.language)}  {values.FechaRecibidoCompras ? ':' + setDateTimeSQLH(values.FechaRecibidoCompras) : ' '} </span>
                        <span style={{ fontSize: 11 }}>{getLabel(CuentasPorPagarLang, 'FechaRecibidoFinanzas', config?.language)} {values.FechaRecibidoFinanzas ? ':' + setDateTimeSQLH(values.FechaRecibidoFinanzas) : ''} </span>
                    </div>
                    <div className='d-flex flex-column mx-5' style={{ alignItems: 'flex-end' }}>
                        <span style={{ fontSize: 11 }}>{getLabel(CuentasPorPagarLang, 'Ingreso', config?.language)}:  {values.UserIngresoCompras} - {setDateTimeSQLH(values.FechaCreado)} </span>
                        <span style={{ fontSize: 11 }}>{getLabel(CuentasPorPagarLang, 'Edicion', config?.language)}: {values.UserEditCompras} - {setDateTimeSQLH(values.FechaEdit)} </span>
                    </div>
                </div>
                : null
            }


            <ModalProductos
                dialogProducto={dialogProducto}
                setDialogProducto={setDialogProducto}
                hideDialog={hideDialogProducto}
                IdProducto={IdProducto}
                toast={toast}

            />

            <ModalProveedorCAI
                proveedoresCAIDialog={dialogCAI}
                setProveedoresCAIDialog={setDialogCAI}
                hideDialog={() => setDialogCAI(false)}
                IdProveedor={values.IdProveedor}
            />





        </Dialog>
    )
}

export default ModalCuentasPorPagarCompras
